<script>
  //接口基本地址
  //const baseUrl = "http://192.168.101.5:8888/vue/";
  const baseUrl = "https://www.ruitongkeji.cn/gameinfo/vue/";
  export default{baseUrl}
</script>



// WEBPACK FOOTER //
// src/Global.vue